(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6397"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6397"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("d8HMG", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $990dfc566758140d$export$6503ec6e8aabbaf; }, function (v) { return $990dfc566758140d$export$6503ec6e8aabbaf = v; });
var $990dfc566758140d$export$6503ec6e8aabbaf;
var $990dfc566758140d$export$f7ad0328861e2f03;
"use strict";
var $990dfc566758140d$var$mapping = new Map();
function $990dfc566758140d$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$990dfc566758140d$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $990dfc566758140d$var$resolve(id) {
    var resolved = $990dfc566758140d$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$990dfc566758140d$export$6503ec6e8aabbaf = $990dfc566758140d$var$register;
$990dfc566758140d$export$f7ad0328861e2f03 = $990dfc566758140d$var$resolve;

});

parcelRegister("3VV9c", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $2dd306457558c0ef$export$bdfd709ae4826697; }, function (v) { return $2dd306457558c0ef$export$bdfd709ae4826697 = v; });
var $2dd306457558c0ef$export$bdfd709ae4826697;
var $2dd306457558c0ef$export$c9e73fbda7da57b6;
var $2dd306457558c0ef$export$5a759dc7a1cfb72a;
"use strict";
var $2dd306457558c0ef$var$bundleURL = {};
function $2dd306457558c0ef$var$getBundleURLCached(id) {
    var value = $2dd306457558c0ef$var$bundleURL[id];
    if (!value) {
        value = $2dd306457558c0ef$var$getBundleURL();
        $2dd306457558c0ef$var$bundleURL[id] = value;
    }
    return value;
}
function $2dd306457558c0ef$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $2dd306457558c0ef$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $2dd306457558c0ef$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $2dd306457558c0ef$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$2dd306457558c0ef$export$bdfd709ae4826697 = $2dd306457558c0ef$var$getBundleURLCached;
$2dd306457558c0ef$export$c9e73fbda7da57b6 = $2dd306457558c0ef$var$getBaseURL;
$2dd306457558c0ef$export$5a759dc7a1cfb72a = $2dd306457558c0ef$var$getOrigin;

});

parcelRegister("bo64b", function(module, exports) {
document.querySelector(".btn.btn-hamburger").addEventListener("click", (e)=>{
    document.querySelector(".navigationDrawer").classList.remove("hide");
});
document.querySelector(".btn.navigationDrawer--closeBtn").addEventListener("click", (e)=>{
    document.querySelector(".navigationDrawer").classList.add("hide");
});
document.querySelectorAll('[data-element="navItem-expander"]').forEach((el)=>{
    el.querySelector(".navigationDrawer--navItemBtn").addEventListener("click", (e)=>{
        if (el.querySelector(".navigationDrawer--navItemExpanded").classList.contains("hide")) {
            el.querySelector(".navigationDrawer--navItemExpanded").classList.remove("hide");
            el.querySelector(".navigationDrawer--navItemBtnArrow").style.rotate = "180deg";
        } else {
            el.querySelector(".navigationDrawer--navItemExpanded").classList.add("hide");
            el.querySelector(".navigationDrawer--navItemBtnArrow").style.rotate = "0deg";
        }
    });
});

});

parcelRegister("dUzBg", function(module, exports) {
const $a20c1ec3db67aafa$var$btnTopNavigationEls = document.querySelectorAll(".btn.link-item");
const $a20c1ec3db67aafa$var$navigationMegaDropdownEl = document.querySelector(".navigationMegaDropdown");






const $a20c1ec3db67aafa$var$setValueDropDownNavigation = (keyElement)=>{
    const dropdownNavigation = {
        services: [
            {
                pageUrl: "intelligent-finance.html",
                logoSrc: new URL((parcelRequire("adyhk"))),
                title: "Intelligent Finance Function"
            },
            {
                pageUrl: "manage-payroll.html",
                logoSrc: new URL((parcelRequire("aLKZd"))),
                title: "Managed Payroll"
            },
            {
                pageUrl: "consulting.html",
                logoSrc: new URL((parcelRequire("lKIeJ"))),
                title: "Consulting"
            }
        ],
        products: [
            {
                pageUrl: "people-management.html",
                logoSrc: new URL((parcelRequire("9ZTUr"))),
                title: "People Management"
            },
            {
                pageUrl: "power-insight.html",
                logoSrc: new URL((parcelRequire("2Jjfx"))),
                title: "Power Insight"
            },
            {
                pageUrl: "all-product.html",
                logoSrc: new URL((parcelRequire("jQZh4"))),
                title: "All Product"
            }
        ]
    };
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelectorAll(".navigationMegaDropdownBtn").forEach((el, index)=>index > 0 && el.remove());
    dropdownNavigation[keyElement].forEach((value)=>{
        const navigationMegaDropdownBtn = $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelector(".navigationMegaDropdownBtn").cloneNode(true);
        navigationMegaDropdownBtn.href = value.pageUrl;
        navigationMegaDropdownBtn.querySelector('[data-element="logoNavigation"]').src = value.logoSrc;
        navigationMegaDropdownBtn.querySelector('[data-element="titleNavigation"]').textContent = value.title;
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelector(".navigationMegaDropdown--inner").appendChild(navigationMegaDropdownBtn);
    });
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelectorAll(".navigationMegaDropdownBtn")[0].remove();
};
$a20c1ec3db67aafa$var$btnTopNavigationEls.forEach((el)=>{
    el.addEventListener("mouseenter", ()=>{
        el.classList.add("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "flex";
        $a20c1ec3db67aafa$var$setValueDropDownNavigation(el.getAttribute("data-element"));
    });
    el.addEventListener("mouseleave", ()=>{
        el.classList.remove("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "none";
    });
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.addEventListener("mouseenter", ()=>{
        el.classList.add("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "flex";
    });
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.addEventListener("mouseleave", ()=>{
        el.classList.remove("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "none";
    });
});

});
parcelRegister("adyhk", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("jXvqm") + "battery-charging.ba1b1745.webp";

});

parcelRegister("aLKZd", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("jXvqm") + "settings-02.d69d69bd.webp";

});

parcelRegister("lKIeJ", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("jXvqm") + "life-buoy.285e728c.webp";

});

parcelRegister("9ZTUr", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("jXvqm") + "people.d532b8d6.webp";

});

parcelRegister("2Jjfx", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("jXvqm") + "grid.f0e29351.webp";

});

parcelRegister("jQZh4", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("jXvqm") + "box.2a34708a.webp";

});


parcelRegister("2SvjK", function(module, exports) {
const $2188eaecfbdd828c$var$preferencePrivacyPopupEl = document.querySelector(".preferencePrivacy-popup");
const $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl = document.querySelector(".preferencePrivacy-popupDetail");
const $2188eaecfbdd828c$var$isCookies = document.cookie.split(";").filter((value)=>value === "_cookies=guest")[0] === "_cookies=guest" || document.cookie.split(";").filter((value)=>value === " _cookies=guest")[0] === " _cookies=guest";
if ($2188eaecfbdd828c$var$isCookies) $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
else $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.add("show");
// Cookies Button
document.querySelector(".btn-cookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.add("show");
// document.querySelector('.cookies-alert-popup').style.display = 'block'
});
document.querySelector(".cookies-accept-btn").addEventListener("click", ()=>{
    // document.querySelector('.cookies-alert-popup').style.display = 'none'
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupEl.querySelector(".btn.preferencePrivacy-popup--closeBtn").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
});
$2188eaecfbdd828c$var$preferencePrivacyPopupEl.querySelector(".btn.btn--rejectAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.add("show");
// document.cookie = '_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC'
});
$2188eaecfbdd828c$var$preferencePrivacyPopupEl.querySelector(".btn.btn--allowAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
document.querySelector(".btn.cookies-learn-more-btn").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.add("show");
    document.querySelector(".cookies-alert-popup").style.display = "none";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.preferencePrivacy-popupDetail--closeBtn").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--rejectAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--allowAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--preferencePrivacy-popupDetailConfirmPreference").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});

});

var $8d945c8d0deea8ab$exports = {};


(parcelRequire("d8HMG")).register((parcelRequire("3VV9c")).getBundleURL("jXvqm"), JSON.parse('["jXvqm","about.fbcab998.js","l36Gp","app-logo.609f4bd5.webp","giQtv","battery-charging.ba1b1745.webp","23FFC","settings-02.d69d69bd.webp","eQ5EQ","life-buoy.285e728c.webp","1BQWm","people.d532b8d6.webp","eSkdY","grid.f0e29351.webp","9Glg9","box.2a34708a.webp","fiu3l","saikhu-khan-popup.9363acbb.webp","83Sc0","chan-ranawat-popup.b520dc9b.webp","90Qqb","saman-fernando-popup.9915c6ed.webp","4z6SN","aasim-sultan-khan-popup.991d322e.webp","4d4aq","sahil-khan-popup.4afeb555.webp","ghIwV","abed-hamwi-popup.e147e1ff.webp","3hdQI","sriram-krishnan-popup.d3c53470.webp","3dFyK","victoria-sergio-popup.9a2d664f.webp","cEF1S","yoga-venugopal-popup.01825270.webp","5aIb8","sam-mehta-popup.bac7d3f4.webp","3Bq8C","chandan-about.9cb58f8a.webp","fJqp7","isuri-about.153b4e15.webp","2Ev7r","harsh-shah-about.8d39a65f.webp","kNoSU","charita-about.b8bfd388.webp"]'));

parcelRequire("bo64b");
parcelRequire("dUzBg");
parcelRequire("2SvjK");
var $4ae4d347a43f9ac4$exports = {};

$4ae4d347a43f9ac4$exports = (parcelRequire("3VV9c")).getBundleURL("jXvqm") + "saikhu-khan-popup.9363acbb.webp";


var $5ed7395804da6f20$exports = {};

$5ed7395804da6f20$exports = (parcelRequire("3VV9c")).getBundleURL("jXvqm") + "chan-ranawat-popup.b520dc9b.webp";


var $f1be7bc63e2cc132$exports = {};

$f1be7bc63e2cc132$exports = (parcelRequire("3VV9c")).getBundleURL("jXvqm") + "saman-fernando-popup.9915c6ed.webp";


var $70ae12232b169c85$exports = {};

$70ae12232b169c85$exports = (parcelRequire("3VV9c")).getBundleURL("jXvqm") + "aasim-sultan-khan-popup.991d322e.webp";


var $66b1781668d47528$exports = {};

$66b1781668d47528$exports = (parcelRequire("3VV9c")).getBundleURL("jXvqm") + "sahil-khan-popup.4afeb555.webp";


var $dff4954db2c4bfb9$exports = {};

$dff4954db2c4bfb9$exports = (parcelRequire("3VV9c")).getBundleURL("jXvqm") + "abed-hamwi-popup.e147e1ff.webp";


var $218aceafbd6c37e9$exports = {};

$218aceafbd6c37e9$exports = (parcelRequire("3VV9c")).getBundleURL("jXvqm") + "sriram-krishnan-popup.d3c53470.webp";


var $ced4b7c84fd665aa$exports = {};

$ced4b7c84fd665aa$exports = (parcelRequire("3VV9c")).getBundleURL("jXvqm") + "victoria-sergio-popup.9a2d664f.webp";


var $f7c2dcf5c4e64d78$exports = {};

$f7c2dcf5c4e64d78$exports = (parcelRequire("3VV9c")).getBundleURL("jXvqm") + "yoga-venugopal-popup.01825270.webp";


var $b390ec54e4c5f5ca$exports = {};

$b390ec54e4c5f5ca$exports = (parcelRequire("3VV9c")).getBundleURL("jXvqm") + "sam-mehta-popup.bac7d3f4.webp";


const $2d781af751937456$var$ourTeams = [
    {
        photo: new URL($4ae4d347a43f9ac4$exports),
        name: "Saikhu Khan",
        jobTitle: "Founder & CEO",
        yearsExperience: "18+",
        description: `Shaikhu Khan, hailing originally from Bhopal, India, embarked on his academic journey at Bhopal University, India, where he earned a BCA degree. His pursuit of knowledge led him to London, where he obtained an MBA from University of East London.

    Throughout his student years, Shaikhu took on diverse roles, showcasing his versatility. His professional journey kicked off as a central kitchen manager for a prominent restaurant and catering group. Subsequently, he ventured into the world of hospitality back-office finance, serving as a data entry operator in a firm specialising in hospitality accounting services.
    
    It was during this period that Shaikhu Khan unearthed his fervor for the hospitality industry, reporting, and delivering exceptional customer service. Over the span of 18 years, he steadily ascended the corporate ladder within the same firm. Holding the position of director, he spearheaded growth strategy, managed human resources, and fueled innovation.
    
    With a client portfolio exceeding 200, Shaikhu played a pivotal role in advising operators on financial matters and achieving impactful results. His expertise extended to guiding various brands in scaling from their initial stages to establishing multiple sites, both domestically and internationally.
    
    In 2020, Shaikhu co-founded Wenodo alongside Chan, Saman, Aasim, and Sahil. From its inception, Shaikhu has led the team as the CEO, steering Wenodo towards success and growth.`,
        linkedInUrl: "#"
    },
    {
        photo: new URL($5ed7395804da6f20$exports),
        name: "Chan Ranawat",
        jobTitle: "Founder & Co-CEO",
        yearsExperience: "18+",
        description: `Chan is an engineering graduate from Nagpur University, India. Following his graduation, he embarked on a journey to London to pursue an MBA at the University of East London. 
    
    After gaining diverse experience in sales, Chan found his specialization in SAP, and for the past 18 years, he has consulted as an SAP architect with various blue-chip companies.
    Chan's primary focus within SAP lies in HR and Payroll, and he has played pivotal roles in numerous HR transformation projects for notable organizations such as William Hill, Deloitte, PWC, SAP, United Biscuits, and even Manchester City Football Club.
    
    The founding of Wenodo has always been Chan's dream, driven by the desire to establish a company with a strong ethos and culture. His passion for hospitality and the creation of exceptional dining experiences is evident. By combining his technological expertise with the relevant hospitality experience of other co-founders, Wenodo is uniquely positioned at the intersection of technology and hospitality. The collective goal is to build a company that everyone involved can take pride in.`,
        linkedInUrl: "#"
    },
    {
        photo: new URL($f1be7bc63e2cc132$exports),
        name: "Saman Fernando",
        jobTitle: "Co-founder & COO,UK",
        yearsExperience: "16+",
        description: `Saman qualified as a Member of Chartered Institute of Management Accountant read his first postgraduate from University Of Middlesex and the second from the University of Sunderland. After completing first year in his BSC at University of Sri Jayewardenepura Sri Lanka embarked on a journey to take on new challenges that led him to London. His foray into the retail sector during his time with CIMA eventually led him to a specialized in Hospitality Finance.
    
    Over the years, Saman has served in pivotal roles working at transactional level to understand the processes in finance and accounting to leading multiple teams and collaborating with diverse clients, he provided comprehensive expertise in management reports and analysis. Understanding the capability of technology Saman's vision for changes the way Management Accounts being prepared led him to architect more automate centred approach to prepare management accounts and reports.
    
    At Wenodo, Saman takes on the role of leading operations and holds the critical position of Chief Operating Officer for Wenodo UK. With a wealth of experience of more than 16 years before co-founding Wenodo, Saman brings a unique blend of financial expertise and operational leadership to drive the success of the company.`,
        linkedInUrl: "#"
    },
    {
        photo: new URL($70ae12232b169c85$exports),
        name: "Aasim Khan",
        jobTitle: "Co-founder & CTO, India",
        yearsExperience: "12+",
        description: `Aasim is a disruptive technology innovator and strategist with demonstrated ability to translate new ideas into solutions and building enterprise applications. He initiated his journey as a software engineer, making valuable contributions to various IT companies, including Rave Infosys, Netlink, and Softnice.
    
    Before co-founding Wenodo, Aasim was working with SoftNice as Director Software Architecture/Business Strategy and also held a pivotal role as a Software Architect at Xeeva, a significant supply chain management product company with a global client base, primarily in the USA and Europe.
    
    At Wenodo, Aasim takes on the role of Chief Technology Officer (CTO) and leads the engineering team. His visionary approach and business accumen is evident in conceptualizing and constructing the technical stack that forms the backbone of Wenodo's success.
    
    Aasim is particularly adept at automation, and he, along with his team, has a knack for creating wonders when it comes to developing exceptional products. His expertise and leadership are instrumental in propelling Wenodo forward in the ever-evolving tech landscape.`,
        linkedInUrl: "#"
    },
    {
        photo: new URL($66b1781668d47528$exports),
        name: "Sahil Khan",
        jobTitle: "COO, Offshore",
        yearsExperience: "12+",
        description: `Sahil, earned his Bachelor's in Business Management from Bangalore University and an MBA from Leeds Metropolitan University in the UK, commenced his professional journey after a short stint with Leeds Borough Council. Upon returning to India, he delved into the finance industry, accumulating nearly a decade of experience in pivotal roles overseeing operations and marketing.
    
    As a co-founder of Wenodo, Sahil contributes a wealth of operational expertise and marketing acumen. He takes the helm of overseas teams in India and Sri Lanka, playing a critical role as the Chief Operating Officer at Wenodo India and also heads the marketing department.
    
    Sahil's composed leadership style adds a valuable dimension to Wenodo, where he not only leads but also serves as a mentor, motivating the team towards shared success.`,
        linkedInUrl: "#"
    },
    {
        photo: new URL($dff4954db2c4bfb9$exports),
        name: "Abed Hamwi",
        jobTitle: "COO, GCC",
        yearsExperience: "12+",
        description: `Abed, the Chief Operating Officer for Wenodo GCC, brings a wealth of expertise in accounting and audit, having earned a Master's degree from a top-tier university in Lebanon and qualifying as a CPA from Maine, USA.
    
    Abed's professional journey began at Grant Thornton, a globally renowned accounting and service firm, where he ascended to the esteemed position of Audit Senior Manager. His leadership was evident in overseeing a diverse portfolio, showcasing proficiency in audit and financial management.
    
    Later in his career, Abed assumed a pivotal role as Finance Manager with a leading Hospitality Group in the GCC region. Here, he played a critical role in orchestrating a comprehensive financial transformation for the group, contributing significantly to its success and growth.
    
    Abed's association with Wenodo stems from a shared passion for hospitality and technology. As the Chief Operating Officer for Wenodo GCC, he has played a key role in the company's growth and success. Abed's unique blend of financial acumen and dedication to the convergence of hospitality and technology has been instrumental in contributing to Wenodo's achievements.`,
        linkedInUrl: "#"
    },
    {
        photo: new URL($218aceafbd6c37e9$exports),
        name: "Sriram Krishnan",
        jobTitle: "Program Director",
        yearsExperience: "12+",
        description: `Sriram Krishnan is a dynamic professional with a strong background and a proven track record in the fields of engineering and IT. An engineering graduate, Sriram further honed his skills by earning an MBA from Institute of Chartered Financial Analysts of India.
    
    His journey in the professional world has been marked by his exceptional aptitude and a can-do attitude, which has propelled him to new heights in his career.
    With vast experience in the IT industry, Sriram has successfully navigated through diverse challenges, leaving an indelible mark on the sector. His clientele includes renowned brands such as M&S, Primark, and Cooperative Group, attesting to his prowess in driving transformation and establishing robust IT processes. Sriram's commitment to operational rigor ensures seamless and efficient processes, ultimately contributing to customer success.
    
    At Wenodo, as the Programme Manager, Sriram brings a wealth of experience in ensuring customer satisfaction and organisational growth. His strategic mindset, coupled with a client-centric approach, positions him as a catalyst for organisational success. Sriram is poised to make a significant impact spearheading customer success initiatives that contribute to sustained growth and excellence in a rapidly evolving business landscape.`,
        linkedInUrl: "#"
    },
    {
        photo: new URL($ced4b7c84fd665aa$exports),
        name: "Victoria Sergio",
        jobTitle: "Clients Account Manager",
        yearsExperience: "12+",
        description: `Victoria, originally from Spain, commenced her studies at Carlos III University in Spain, culminating in the completion of her bachelor\u{2019}s degree in economics and journalism. Subsequently, she made the decision to relocate to London to pursue her career in finance. Initially employed in the front of the house at a restaurant, she transitioned to hospitality finance. Her perseverance played a pivotal role in her transition to the finance sector, showcasing her commitment to pursuing and succeeding in her chosen career path. Currently, she is an ACCA part-qualified accountant with seven years of experience in accounting.
    
    As a Senior Manager at Wenodo, Victoria brings her wealth of experience and expertise to a leadership role. In this capacity, she not only manages clients but also mentors junior staff, implements advanced accounting practices, and contributes to the development of financial strategies that align with Wenodo's objectives. Victoria's senior position reflects her proficiency in managing both clients and internal financial processes within the organization.`,
        linkedInUrl: "#"
    },
    {
        photo: new URL($f7c2dcf5c4e64d78$exports),
        name: "Yoga Venugopal",
        jobTitle: "Customer Success Manager",
        yearsExperience: "12+",
        description: `Yoga, an accomplished professional with a diverse career across various industries, holds an MBA from Madurai Kamaraj University. Beginning in the finance sector, Yoga focused on the retail banking division of ICICI Bank, later transitioning to ICICI Bank London, where they gained insights into international business practices and human resource management.
    When the opportunity arose to work with SMEs in the hospitality industry, Yoga wanted to embark on the prospect of making an impact on small businesses. Engaging with diverse restaurant operations, Yoga developed a holistic understanding of operational intricacies. Before joining Wenodo, Yoga assumed the role of Head of Finance at the Wellfound Group, seizing the opportunity to shape financial strategies for a multifaceted organization.
    
    At Wenodo, as Customer Success Manager, Yoga brings extensive experience to the team, aligning with Wenodo's innovative approach and commitment to excellence. As a key player, Yoga fosters a collaborative work environment and leverages a versatile skill set honed across diverse industries, contributing to Wenodo's ongoing success.`,
        linkedInUrl: "#"
    },
    {
        photo: new URL($b390ec54e4c5f5ca$exports),
        name: "Sam Mehta",
        jobTitle: "Global Operations Manager",
        yearsExperience: "12+",
        description: `Hailing from Gujarat, India, Sam Mehta is a distinguished professional in the realm of management accounts. His academic journey includes a Bachelors degree in commerce specializing in accounts and finance from Mumbai University, India, complemented by a CFA from Tripura University, India.
    
    With a career spanning over 12 years, Sam's expertise lies in management accounts, encompassing cash flow management and budget management, team leadership, people management, and the cultivation of client relations. His professional journey began as an analyst, and through unwavering dedication, he ascended to the esteemed position of Operations Manager. Notably, he initiated and successfully expanded his team to an impressive 150 individuals.
    
    Sam's global perspective is reflected in his extensive experience working with clients in the UK, USA, and UAE regions. This exposure has not only broadened his professional horizons but has also honed his skills in navigating diverse international business landscapes.
    
    A distinctive aspect of Sam's skill set is his proficiency in onboarding new clients, a process that includes the seamless migration of data between software platforms and the establishment of new client relationships. This showcases his adaptability and technical acumen, setting him apart in the dynamic field of management accounts. Sam\u{2019}s professional journey is marked by a commitment to excellence, leadership, and a global perspective.`,
        linkedInUrl: "#"
    }
];
var $2d781af751937456$export$2e2bcd8739ae039 = $2d781af751937456$var$ourTeams;


var $85028495eef161ff$exports = {};

$85028495eef161ff$exports = (parcelRequire("3VV9c")).getBundleURL("jXvqm") + "chandan-about.9cb58f8a.webp";


var $d8a9a5a8c9a352b9$exports = {};

$d8a9a5a8c9a352b9$exports = (parcelRequire("3VV9c")).getBundleURL("jXvqm") + "app-logo.609f4bd5.webp";


var $b5f0b91b15bbf063$exports = {};

$b5f0b91b15bbf063$exports = (parcelRequire("3VV9c")).getBundleURL("jXvqm") + "isuri-about.153b4e15.webp";



var $9d16e75455d2e201$exports = {};

$9d16e75455d2e201$exports = (parcelRequire("3VV9c")).getBundleURL("jXvqm") + "harsh-shah-about.8d39a65f.webp";



var $c89dff507c294838$exports = {};

$c89dff507c294838$exports = (parcelRequire("3VV9c")).getBundleURL("jXvqm") + "charita-about.b8bfd388.webp";



const $b9ddbb06a074ac57$var$aboutTestimonials = [
    {
        photo: new URL($85028495eef161ff$exports),
        name: "Chandan",
        jobPosition: "Team Member",
        testimonial: "At Wenodo, teamwork isn't just a concept; it's the heartbeat of our environment. The atmosphere is not only amazing but also incredibly comfortable, fostering collaboration and innovation. Every team member consistently gives their all towards our shared goals, setting a truly inspiring standard. The way we tackle problems here is a refreshing approach that continuously expands my learning. There's a tangible sense of shared success, celebrating every job well done. Wenodo isn't just a company; it's a community that thrives on collective achievement.",
        companyLogo: new URL($d8a9a5a8c9a352b9$exports),
        companyLogoClass: "wenodo"
    },
    {
        photo: new URL($b5f0b91b15bbf063$exports),
        name: "Isuri",
        jobPosition: "Team Member",
        testimonial: "My time at Wenodo has been incredibly satisfying. It is a fantastic company with a welcoming atmosphere and extremely supportive management. I am surrounded by a talented and diverse team who shares their knowledge in a friendly manner. Wenodo cares about their employees and customers and works considerably and competently to succeed. Being a fresher, Wenodo encouraged me to stretch myself and improve my skills. Working with Wenodo is a great pleasure and a privilege for me. I'm grateful to be a part of the Wenodo team and look forward to contributing my best in the years to come.",
        companyLogo: new URL($d8a9a5a8c9a352b9$exports),
        companyLogoClass: "wenodo"
    },
    // {
    //   photo: new URL('../image/johny-smith.webp?as=webp', import.meta.url),
    //   name: 'Johny Smith',
    //   jobPosition: 'Co Founder Luca Restaurant',
    //   testimonial: "Wenodo's team is exceptional! Their profound knowledge of the hospitality industry and their friendly customer service have been invaluable to our business. Their expertise in the intricacies of our industry coupled with their approachable and supportive service have made working with them a true pleasure. They understand our needs and offer tailored solutions, making a significant difference in our operations.",
    //   companyLogo: new URL('../image/luca-company.webp?as=webp', import.meta.url),
    //   companyLogoClass: 'luca'
    // },
    {
        photo: new URL($9d16e75455d2e201$exports),
        name: "Harsh Shah",
        jobPosition: "Senior Manager",
        testimonial: "Wenodo's team is exceptional! Their profound knowledge of the hospitality industry and their friendly customer service have been invaluable to our business. Their expertise in the intricacies of our industry coupled with their approachable and supportive service have made working with them a true pleasure. They understand our needs and offer tailored solutions, making a significant difference in our operations.",
        companyLogo: new URL($d8a9a5a8c9a352b9$exports),
        companyLogoClass: "wenodo"
    },
    {
        photo: new URL($c89dff507c294838$exports),
        name: "Charitha",
        jobPosition: "Assistant Manager",
        testimonial: "Working at Wenodo has been an incredible journey of growth and learning. The ability to work from home allowed me to achieve a perfect balance between my personal and professional life. I am genuinely grateful for the trust that Wenodo places in its employees. Also, the company's emphasis on open communication and regular check-ins has made me feel valued and supported. The other aspect that I really appreciate is its unwavering commitment to exceptional client service. Thank you for giving me the chance to be a part of this great team. I am excited to continue contributing my best!",
        companyLogo: new URL($d8a9a5a8c9a352b9$exports),
        companyLogoClass: "wenodo"
    }
];
var $b9ddbb06a074ac57$export$2e2bcd8739ae039 = $b9ddbb06a074ac57$var$aboutTestimonials;


const $bbfd389139dbb276$var$preHeadingIcon = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="32" height="32" rx="16" fill="#1DCA5D"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.8337 14.2283C13.2713 13.8583 14.3337 12.5532 14.3337 11C14.3337 9.15905 12.8413 7.66667 11.0003 7.66667C9.15938 7.66667 7.66699 9.15905 7.66699 11C7.66699 12.5532 8.7293 13.8583 10.167 14.2283V23.5C10.167 23.9602 10.5401 24.3333 11.0003 24.3333C11.4606 24.3333 11.8337 23.9602 11.8337 23.5V14.2283Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.667 21C17.667 19.4468 18.7293 18.1417 20.167 17.7717V12.6667C20.167 12.4457 20.0792 12.2337 19.9229 12.0774C19.7666 11.9211 19.5547 11.8333 19.3337 11.8333H16.8337C16.3734 11.8333 16.0003 11.4602 16.0003 11C16.0003 10.5398 16.3734 10.1667 16.8337 10.1667H19.3337C19.9967 10.1667 20.6326 10.4301 21.1014 10.8989C21.5703 11.3677 21.8337 12.0036 21.8337 12.6667V17.7717C23.2713 18.1417 24.3337 19.4468 24.3337 21C24.3337 22.8409 22.8413 24.3333 21.0003 24.3333C19.1594 24.3333 17.667 22.8409 17.667 21Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.6667 21C17.6667 19.4468 18.729 18.1417 20.1667 17.7717V12.6667C20.1667 12.4457 20.0789 12.2337 19.9226 12.0774C19.7663 11.9211 19.5543 11.8333 19.3333 11.8333H16.8333C16.3731 11.8333 16 11.4602 16 11C16 10.5398 16.3731 10.1667 16.8333 10.1667H19.3333C19.9964 10.1667 20.6323 10.4301 21.1011 10.8989C21.5699 11.3677 21.8333 12.0036 21.8333 12.6667V17.7717C23.271 18.1417 24.3333 19.4468 24.3333 21C24.3333 22.8409 22.8409 24.3333 21 24.3333C19.1591 24.3333 17.6667 22.8409 17.6667 21Z" fill="#77DF9E"/>
</svg>`;
document.querySelectorAll(".testimonial__about--preHeadingIcon").forEach((el)=>{
    el.innerHTML += $bbfd389139dbb276$var$preHeadingIcon;
});
document.querySelector(".team__about--preHeadingIcon").innerHTML += $bbfd389139dbb276$var$preHeadingIcon;
document.querySelector(".teamActivity__about--preHeadingIcon").innerHTML += $bbfd389139dbb276$var$preHeadingIcon;
document.querySelector(".career__about--preHeadingIcon").innerHTML += $bbfd389139dbb276$var$preHeadingIcon;
// Arrow Up Icon Button
const $bbfd389139dbb276$var$arrowUpIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.83301 14.1667L14.1663 5.83334M14.1663 5.83334H5.83301M14.1663 5.83334V14.1667" stroke="#05A6F0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
document.querySelectorAll(".btn.btn-book-demo").forEach((el)=>{
    el.innerHTML += $bbfd389139dbb276$var$arrowUpIcon;
});
const $bbfd389139dbb276$var$chevronDownIcon = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 4.5L6 7.5L9 4.5" stroke="#94A3B8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
document.querySelectorAll(".link-item .arrow-down").forEach((el)=>{
    el.innerHTML += $bbfd389139dbb276$var$chevronDownIcon;
});
const $bbfd389139dbb276$var$hamburgerIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 12H21M3 6H21M3 18H21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
document.querySelector(".btn-hamburger").innerHTML += $bbfd389139dbb276$var$hamburgerIcon;
const $bbfd389139dbb276$var$timelineCardIcon = `<svg width="100%" height="100%" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="48" height="48" rx="24" fill="white" fill-opacity="0.2"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M19.8327 22.2282C21.2704 21.8581 22.3327 20.553 22.3327 18.9998C22.3327 17.1589 20.8403 15.6665 18.9993 15.6665C17.1584 15.6665 15.666 17.1589 15.666 18.9998C15.666 20.553 16.7283 21.8581 18.166 22.2282V31.4998C18.166 31.9601 18.5391 32.3332 18.9993 32.3332C19.4596 32.3332 19.8327 31.9601 19.8327 31.4998V22.2282Z" fill="white" fill-opacity="0.5"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M25.666 28.9998C25.666 27.4466 26.7283 26.1416 28.166 25.7715V20.6665C28.166 20.4455 28.0782 20.2335 27.9219 20.0772C27.7657 19.921 27.5537 19.8332 27.3327 19.8332H24.8327C24.3724 19.8332 23.9993 19.4601 23.9993 18.9998C23.9993 18.5396 24.3724 18.1665 24.8327 18.1665H27.3327C27.9957 18.1665 28.6316 18.4299 29.1004 18.8987C29.5693 19.3676 29.8327 20.0035 29.8327 20.6665V25.7715C31.2704 26.1416 32.3327 27.4466 32.3327 28.9998C32.3327 30.8408 30.8403 32.3332 28.9993 32.3332C27.1584 32.3332 25.666 30.8408 25.666 28.9998Z" fill="white" fill-opacity="0.5"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M25.6667 29C25.6667 27.4468 26.729 26.1417 28.1667 25.7717V20.6667C28.1667 20.4457 28.0789 20.2337 27.9226 20.0774C27.7663 19.9212 27.5543 19.8334 27.3333 19.8334H24.8333C24.3731 19.8334 24 19.4603 24 19C24 18.5398 24.3731 18.1667 24.8333 18.1667H27.3333C27.9964 18.1667 28.6323 18.4301 29.1011 18.8989C29.5699 19.3678 29.8333 20.0036 29.8333 20.6667V25.7717C31.271 26.1417 32.3333 27.4468 32.3333 29C32.3333 30.841 30.8409 32.3334 29 32.3334C27.1591 32.3334 25.6667 30.841 25.6667 29Z" fill="white"/>
</svg>`;
document.querySelectorAll(".timeline__about--cardLogo").forEach((el)=>{
    el.innerHTML += $bbfd389139dbb276$var$timelineCardIcon;
});
const $bbfd389139dbb276$var$linkedinIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.8333 17.5H7.5V7.5H10.8333V9.16667C11.5439 8.26271 12.6214 7.72381 13.7708 7.6975C15.838 7.70898 17.506 9.39115 17.5 11.4583V17.5H14.1667V11.875C14.0334 10.9439 13.2348 10.253 12.2942 10.255C11.8827 10.268 11.4944 10.4481 11.2187 10.7539C10.943 11.0596 10.8039 11.4644 10.8333 11.875V17.5ZM5.83333 17.5H2.5V7.5H5.83333V17.5ZM4.16667 5.83333C3.24619 5.83333 2.5 5.08714 2.5 4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5C5.08714 2.5 5.83333 3.24619 5.83333 4.16667C5.83333 4.60869 5.65774 5.03262 5.34518 5.34518C5.03262 5.65774 4.60869 5.83333 4.16667 5.83333Z"/>
</svg>`;
document.querySelectorAll(".team__about--cardLinkedIn").forEach((el)=>{
    el.innerHTML += $bbfd389139dbb276$var$linkedinIcon;
});
const $bbfd389139dbb276$var$rectangleBottomCardActive = '<svg width="100%" height="14" viewBox="0 0 234 14" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none"><path d="M0 0H234L0 12V0Z" fill="white"/><path d="M0 12L234 0V2L0 14V12Z" fill="url(#paint0_linear_3145_6432)"/><defs><linearGradient id="paint0_linear_3145_6432" x1="-2" y1="10" x2="234" y2="1.54961e-05" gradientUnits="userSpaceOnUse"><stop stop-color="#05A6F0"/><stop offset="1" stop-color="#1DCA5D"/></linearGradient></defs></svg>';
const $bbfd389139dbb276$var$rectangleBottomCard = '<svg width="100%" height="14" viewBox="0 0 234 14" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none"><path d="M0 0H234L0 12V0Z" fill="white"/><path d="M0 12L234 0V2L0 14V12Z" fill="#E2E8F0"/></svg>';
document.querySelectorAll(".team__about--cardRectangleBottom").forEach((el)=>{
    el.innerHTML = $bbfd389139dbb276$var$rectangleBottomCard;
});
document.querySelectorAll(".team__about--cardRectangleBottom.active").forEach((el)=>{
    el.innerHTML = $bbfd389139dbb276$var$rectangleBottomCardActive;
});
const $bbfd389139dbb276$var$arrowUpIconCardTeam = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 17L17 7M17 7H7M17 7V17" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
document.querySelectorAll(".team__about--cardArrowUpIcon").forEach((el)=>{
    el.innerHTML += $bbfd389139dbb276$var$arrowUpIconCardTeam;
});
document.querySelectorAll(".swiper-slide.team__about--card").forEach((el)=>{
    el.addEventListener("mouseenter", ()=>{
        // console.log('enter')
        el.querySelector(".team__about--cardRectangleBottom").innerHTML = $bbfd389139dbb276$var$rectangleBottomCardActive;
    });
    el.addEventListener("mouseleave", ()=>{
        // console.log('leave')
        el.querySelector(".team__about--cardRectangleBottom").innerHTML = $bbfd389139dbb276$var$rectangleBottomCard;
    });
});
// eslint-disable-next-line no-unused-vars
const $bbfd389139dbb276$var$swiper = new Swiper(".swiper.team__about--swiper", {
    // Optional parameters
    // direction: 'vertical',
    loop: false,
    // centeredSlides: true,
    slidesPerView: 1.145,
    spaceBetween: 24,
    // If we need pagination
    // pagination: {
    //   el: '.swiper-pagination'
    // },
    // Navigation arrows
    navigation: {
        nextEl: ".team__about--navigationNextBtn",
        prevEl: ".team__about--navigationPreviousBtn"
    },
    // And if we need scrollbar
    // scrollbar: {
    //   el: '.swiper-scrollbar'
    // }
    breakpoints: {
        576: {
            slidesPerView: 2
        },
        768: {
            slidesPerView: 2.5
        },
        992: {
            slidesPerView: 3.21
        },
        1200: {
            slidesPerView: 4
        }
    }
});
// eslint-disable-next-line no-unused-vars
const $bbfd389139dbb276$var$swiperAboutTestimonial = new Swiper(".swiper.testimonial__about--swiper", {
    // Optional parameters
    direction: "horizontal",
    loop: false,
    slidesPerView: 1.075,
    spaceBetween: 24,
    mousewheel: true,
    speed: 350,
    breakpoints: {
        //   576: {
        //     slidesPerView: 2
        //   },
        992: {
            centeredSlides: true,
            slidesPerView: "auto",
            direction: "vertical"
        }
    }
});
setTimeout(function() {
    $bbfd389139dbb276$var$swiperAboutTestimonial.update();
}, 500);
const $bbfd389139dbb276$var$isLarge = window.matchMedia("(min-width: 992px)");
if ($bbfd389139dbb276$var$isLarge.matches) // Then trigger an alert
$bbfd389139dbb276$var$swiperAboutTestimonial.on("slideChange", function() {
    if ($bbfd389139dbb276$var$swiperAboutTestimonial.activeIndex === 0) {
        document.querySelector(".swiper.testimonial__about--swiper .swiper-wrapper").style.marginTop = "-20%";
        document.querySelector(".testimonial__about--swiper").style.setProperty("--zIndexBefore-pseudo", 0);
        document.querySelector(".testimonial__about--swiper").style.setProperty("--zIndexAfter-pseudo", 2);
    } else if ($bbfd389139dbb276$var$swiperAboutTestimonial.activeIndex === 4) {
        document.querySelector(".swiper.testimonial__about--swiper .swiper-wrapper").style.marginBottom = "-20%";
        document.querySelector(".testimonial__about--swiper").style.setProperty("--zIndexBefore-pseudo", 2);
        document.querySelector(".testimonial__about--swiper").style.setProperty("--zIndexAfter-pseudo", 0);
    } else {
        // document.querySelector('.testimonial__about--swiper::before').style.zIndex = 2
        document.querySelector(".swiper.testimonial__about--swiper .swiper-wrapper").style.marginTop = "auto";
        document.querySelector(".swiper.testimonial__about--swiper .swiper-wrapper").style.marginBottom = "auto";
        document.querySelector(".testimonial__about--swiper").style.setProperty("--zIndexBefore-pseudo", 2);
        document.querySelector(".testimonial__about--swiper").style.setProperty("--zIndexAfter-pseudo", 2);
    }
});
const $bbfd389139dbb276$var$closeBtnPopUpIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17 7L7 17M7 7L17 17" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
document.querySelector(".popupTeam__about--btnClose").innerHTML += $bbfd389139dbb276$var$closeBtnPopUpIcon;
const $bbfd389139dbb276$var$linkedInIcon = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.8333 17.5H7.5V7.5H10.8333V9.16667C11.5439 8.26271 12.6214 7.72381 13.7708 7.6975C15.838 7.70898 17.506 9.39115 17.5 11.4583V17.5H14.1667V11.875C14.0334 10.9439 13.2348 10.253 12.2942 10.255C11.8827 10.268 11.4944 10.4481 11.2187 10.7539C10.943 11.0596 10.8039 11.4644 10.8333 11.875V17.5ZM5.83333 17.5H2.5V7.5H5.83333V17.5ZM4.16667 5.83333C3.24619 5.83333 2.5 5.08714 2.5 4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5C5.08714 2.5 5.83333 3.24619 5.83333 4.16667C5.83333 4.60869 5.65774 5.03262 5.34518 5.34518C5.03262 5.65774 4.60869 5.83333 4.16667 5.83333Z" fill="#05A6F0"/></svg>';
document.querySelector(".popupTeam__about--urlLinkedinIcon").innerHTML += $bbfd389139dbb276$var$linkedInIcon;
const $bbfd389139dbb276$var$popUpAboutTeam = document.querySelector(".popupTeam__about");
const $bbfd389139dbb276$var$arrowUpCardTeamBtns = document.querySelectorAll(".team__about--cardArrowUpIcon");
$bbfd389139dbb276$var$arrowUpCardTeamBtns.forEach((el, index)=>{
    el.addEventListener("click", ()=>{
        const _dataTeam = (0, $2d781af751937456$export$2e2bcd8739ae039)[index];
        $bbfd389139dbb276$var$popUpAboutTeam.querySelector(".popupTeam__about--photo .img").src = _dataTeam.photo;
        $bbfd389139dbb276$var$popUpAboutTeam.querySelector(".popupTeam__about--name").innerHTML = _dataTeam.name;
        $bbfd389139dbb276$var$popUpAboutTeam.querySelector(".popupTeam__about--jobTitle").innerHTML = _dataTeam.jobTitle;
        $bbfd389139dbb276$var$popUpAboutTeam.querySelector(".popupTeam__about--yearExperience").innerHTML = _dataTeam.yearsExperience + " Years Experience";
        $bbfd389139dbb276$var$popUpAboutTeam.querySelector(".popupTeam__about--desc").innerHTML = _dataTeam.description;
        $bbfd389139dbb276$var$popUpAboutTeam.querySelector(".popupTeam__about--urlLinkedin").href = _dataTeam.linkedInUrl;
        $bbfd389139dbb276$var$popUpAboutTeam.style.display = "flex";
    });
});
$bbfd389139dbb276$var$popUpAboutTeam.querySelector(".btn.popupTeam__about--btnClose").addEventListener("click", ()=>{
    $bbfd389139dbb276$var$popUpAboutTeam.style.display = "none";
});
$bbfd389139dbb276$var$popUpAboutTeam.querySelector(".popupTeam__about--overlay").addEventListener("click", ()=>{
    $bbfd389139dbb276$var$popUpAboutTeam.style.display = "none";
});
// Animation Single Element
const $bbfd389139dbb276$var$singleElements = [
    // Hero
    [
        ".hero__about--preHeading",
        "animate__fadeInUp",
        "animate__delay-1s"
    ],
    [
        ".hero__about--title",
        "animate__fadeInUpOneTenth",
        "animate__delay-3s"
    ],
    [
        ".hero__about--desc",
        "animate__fadeInUpOneTenth",
        "animate__delay-5s"
    ],
    [
        ".hero__about--card",
        "animate__fadeInUpOneTenth",
        "animate__delay-7s"
    ],
    [
        ".hero__about--illustration .img",
        "animate__fadeInUpOneTenth",
        "animate__delay-9s"
    ],
    // Our Values
    [
        ".ourValues__about--title",
        "animate__fadeInUp",
        "animate__delay-1s"
    ],
    [
        ".ourValues__about--content",
        "animate__fadeInUpOneTenth",
        "animate__delay-1s"
    ],
    // About Testimonial
    [
        ".testimonial__about--left .testimonial__about--preHeading",
        "animate__fadeInUpOneTenth",
        "animate__delay-1s"
    ],
    [
        ".testimonial__about--title",
        "animate__fadeInUpOneTenth",
        "animate__delay-3s"
    ],
    [
        ".testimonial__about--illustration",
        "animate__fadeInUpOneTenth",
        "animate__delay-5s"
    ],
    [
        ".testimonial__about--right .testimonial__about--preHeading",
        "animate__fadeInUpOneTenth",
        "animate__delay-7s"
    ],
    [
        ".testimonial__about--swiper",
        "animate__fadeInUpOneTenth",
        "animate__delay-9s"
    ],
    // Our Teams
    [
        ".team__about--preHeading",
        "animate__fadeInUp",
        "animate__delay-1s"
    ],
    [
        ".team__about--title",
        "animate__fadeInUp",
        "animate__delay-3s"
    ],
    [
        ".team__about--swiper",
        "animate__fadeInUpOneTenth",
        "animate__delay-5s"
    ],
    [
        ".team__about--footer",
        "animate__fadeInUpOneTenth",
        "animate__delay-7s"
    ],
    // Team Activity
    [
        ".teamActivity__about--preHeading",
        "animate__fadeInUp",
        "animate__delay-3s"
    ],
    [
        ".teamActivity__about--title",
        "animate__fadeInUpOneTenth",
        "animate__delay-5s"
    ],
    [
        ".teamActivity__about--desc",
        "animate__fadeInUpOneTenth",
        "animate__delay-7s"
    ],
    // Career
    [
        ".career__about--preHeading",
        "animate__fadeInUp",
        "animate__delay-3s"
    ],
    [
        ".career__about--title",
        "animate__fadeInUpOneTenth",
        "animate__delay-5s"
    ],
    [
        ".career__about--desc",
        "animate__fadeInUpOneTenth",
        "animate__delay-7s"
    ],
    [
        ".career__about--btnApplyNow",
        "animate__fadeInUpOneTenth",
        "animate__delay-9s"
    ],
    [
        ".career__about--illustration",
        "animate__fadeInUpOneTenth",
        "animate__delay-11s"
    ]
];
// Create the observer like the examples above
const $bbfd389139dbb276$var$observer = new IntersectionObserver((entries)=>{
    entries.forEach((entry, index)=>{
        if (entry.isIntersecting) entry.target.classList.add("animate__animated", $bbfd389139dbb276$var$singleElements[index][1], $bbfd389139dbb276$var$singleElements[index][2]);
    // entry.target.classList.remove('animate__animated')
    });
});
// , { threshold: 0.25 }
$bbfd389139dbb276$var$singleElements.forEach((element)=>{
    $bbfd389139dbb276$var$observer.observe(document.querySelector(element[0]));
});
// Animation CTA Element
const $bbfd389139dbb276$var$ctaElements = [
    // CTA
    [
        ".section-cta__title",
        "animate__fadeInUp",
        "animate__delay-1s"
    ],
    [
        ".section-cta__description",
        "animate__fadeInUp",
        "animate__delay-3s"
    ],
    [
        ".btn-book-demo",
        "animate__fadeInUpOneTenth",
        "animate__delay-5s"
    ]
];
$bbfd389139dbb276$var$ctaElements.forEach((element)=>{
    document.querySelectorAll(element[0]).forEach((el)=>{
        $bbfd389139dbb276$var$observer.observe(el);
    });
});
const $bbfd389139dbb276$var$visiMissionElements = [
    // VisiMission
    [
        ".vision__about--title",
        "animate__fadeInUp",
        "animate__delay-1s"
    ],
    [
        ".vision__about--subtitle",
        "animate__fadeInUp",
        "animate__delay-3s"
    ],
    [
        ".vision__about--description",
        "animate__fadeInUpOneTenth",
        "animate__delay-5s"
    ],
    [
        ".vision__about--illustration",
        "animate__fadeInUpOneTenth",
        "animate__delay-7s"
    ]
];
$bbfd389139dbb276$var$visiMissionElements.forEach((element)=>{
    document.querySelectorAll(element[0]).forEach((el)=>{
        $bbfd389139dbb276$var$observer.observe(el);
    });
});
const $bbfd389139dbb276$var$timelineAboutEl = document.querySelector(".timeline__about");
// Create the observer like the examples above
const $bbfd389139dbb276$var$observerTimelineAbout = new IntersectionObserver((entries)=>{
    entries.forEach((entry, index)=>{
        if (entry.isIntersecting) {
            // entry.target.classList.add('animate__animated', singleElements[index][1], singleElements[index][2])
            entry.target.querySelector(".timeline__about--line").classList.add("animate");
            entry.target.querySelectorAll(".timeline__about--card").forEach((el)=>{
                el.classList.add("animate");
            });
        }
    // entry.target.classList.remove('animate__animated')
    });
});
$bbfd389139dbb276$var$observerTimelineAbout.observe($bbfd389139dbb276$var$timelineAboutEl);
const $bbfd389139dbb276$var$testimonialCardParent = document.querySelector(".swiper.testimonial__about--swiper .swiper-wrapper");
(0, $b9ddbb06a074ac57$export$2e2bcd8739ae039).forEach((aboutTestimonial)=>{
    const aboutTestimonialCardEl = document.querySelector('[data-element="testimonial-about-card-slider"]').cloneNode(true);
    aboutTestimonialCardEl.querySelector('[data-element="name"]').textContent = aboutTestimonial.name;
    aboutTestimonialCardEl.querySelector('[data-element="job-position"]').textContent = aboutTestimonial.jobPosition;
    aboutTestimonialCardEl.querySelector('[data-element="about-testimonial"]').innerHTML = aboutTestimonial.testimonial;
    aboutTestimonialCardEl.querySelector('[data-element="company-logo"]').src = aboutTestimonial.companyLogo;
    aboutTestimonialCardEl.querySelector('[data-element="company-logo"]').classList.add(aboutTestimonial.companyLogoClass);
    aboutTestimonialCardEl.querySelector('[data-element="photo"]').src = aboutTestimonial.photo;
    $bbfd389139dbb276$var$testimonialCardParent.appendChild(aboutTestimonialCardEl);
});
document.querySelectorAll('[data-element="testimonial-about-card-slider"]')[0].remove();

})();
//# sourceMappingURL=about.fbcab998.js.map
